module.exports = __webpack_public_path__ + "static/media/5.ae12441d.jpg";